import {Inject, Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {Store} from '@ngrx/store';
import {EVENT_ACTIONS} from '../store/actions';
import {BundleCall} from '@ispm-client/modules/aggregator/services';
import {cloneDeep, get, has, isEmpty, isEqual, isNull, map as lodashMap, sortBy, set, isArray, uniq} from 'lodash';
import {AgregationService} from '@ispm-client/modules/aggregator/services/aggregator.service';
import {
    IEvent,
    IEventDefinition,
    IEventMapParam,
    IEventsDefAndSelectedState
} from '@ispm-client/modules/events/Interfaces/index';
import {distinctUntilChanged, filter, map, take} from 'rxjs/operators';
import * as immutable from 'immutable';
import {Map as immutemap} from 'immutable';
import {IspmHttpClient} from '@ispm/core/services/ispm-http-client';
import {CoreActionCreatorService} from '@ispm/core/services/core-action-creator.service';
import {CORE_ACTIONS} from '@ispm/core/constants/core-actions.constant';
import {ContextProviderService} from '@ispm-client/modules/context-provider/services/context-provider.service';
import {FormHandlerService} from '@ispm/dynamic-form/services/form-handler.service';
import {FileService} from '@ispm-client/modules/file-module/services/file.service';
import {IDiagnosticOrder} from "@ispm/test/interfaces/diagnostic-order.interface";
import {currentDiagnosticOrderSelector} from "@ispm/test/store/diagnostic-order.selector";
import moment from 'moment';
import {DatePipe} from '@angular/common';
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import {WorkflowService} from "@ispm/workflow/services/workflow.service";
import {RevisionStatus} from "@ispm/workflow/constants/revisionStatus.enum";
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {AuthenticationService} from "@ispm/user/services/authentication.service";

@Injectable()
export class EventService {
  public static ModalLoaderTunnelName = 'EVENT_POPUP_MODAL_CHANNEL';
  public store$: Store<IEventsDefAndSelectedState>;
  public allDefinitions:Map<string,IEventDefinition> = new Map<string, IEventDefinition>();
  private currentEventDefs: Array<string> = [];
  private isformsFecthed:boolean =  false;
  private fileCached: Map<string, Observable<any>> = new Map();
  private appStore$: Store<any>;
  private stopInterval:any;
  public onCompleteWorkflow:Observable<IEvent>;
  public currentActiveFile = new BehaviorSubject("");
  public isButtonDisable = new BehaviorSubject(false);
  private currentTabName: string | null = null;
  private viewWizard = false;

  get authService() {
    return this.coreAC.getUpgradeInjectorStatus().pipe(
      filter(status => status),
      take(1),
      map(_ => this.injector.get(AuthenticationService))
    ).toPromise();
  }

  constructor(private store: Store<any>,
              private _bundleCall: BundleCall,
              private _agregatorService: AgregationService,
              private _ispmHttpClient: IspmHttpClient,
              protected injector: Injector,
              protected coreAC: CoreActionCreatorService,
              private _formHandler: FormHandlerService,
              private _contextProviderService: ContextProviderService,
              private _fileService: FileService,
              private _datePipe: DatePipe,
              private _workflowService: WorkflowService,
              private _aggregatorService: AgregationService,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE) {
    this.appStore$ = store;
    this.store$ = store.select('events') as any;
    this.getAndStoreAllEventDefinitions();
  }

  /**
   * Getter for current active tab title
   */
  public get currentTabTitle(): string | null {
    return this.currentTabName;
  }

  /**
   * Setter for current active tab title
   */
  public set currentTabTitle(tabName: string) {
    this.currentTabName = tabName ?? null;
  }

  public test(): Observable<any> {
    return this.store.select('environmentDetails')
  }

  private async getAndStoreAllEventDefinitions() {
    /***
     * Not using aggregator service here as evendefinition is organisation specific not
     * patient specific on change patient we are clearing bundle data of store which is
     * created by aggregator module */
    const currentUser = (await this.authService).user;
    const eventDefnPayload = {
      'queries': [{
        'targetResource': 'EventDefinition',
        'queryString': `context=${currentUser ? currentUser.organization : null}`
      }]
    };

    this._bundleCall.searchCall(eventDefnPayload).subscribe(data => {
      const definitions = get(data, '[0].response.entry');
      let eventTypes, definition, defitem;
      const allDefinitions: Map<string, IEventDefinition> = new Map();
      definitions.forEach(element => {
        defitem = element.resource;
        eventTypes = defitem.context.filter(function (e) {
          return e.resourceType === 'eventType';
        });

        eventTypes.forEach(evetType => {
          definition = { 'ui': defitem.ui, 'common': defitem.common, 'backend': defitem.backend };
          allDefinitions.set(evetType.reference, definition);
        });
      });
      this.allDefinitions = allDefinitions;
      this.prefetchForms();
      this.store$.dispatch({
        type: EVENT_ACTIONS.ADD_EVENTS_DEFINITION,
        payload: allDefinitions
      });

    });
  }

  /*** Get all events from Store if not there fetch from backend
   * via aggregator service
   */
  public getAllEventsAndStore(queryParams?: string): Promise<any> {
    const dataBindings: Array<any> = [];
    dataBindings.push({
      'queryString': `context=$(currentPatient.link)${queryParams ? queryParams : ''}`,
      'targetResource': 'Event'
    });
    // 'identifierType': 'array',
    // 'identifier': 'events',
    return new Promise(resolve => {
      this._bundleCall.queryFiller(dataBindings[0].queryString).then(dd => {
        dataBindings[0].queryString = dd;
        this._bundleCall.searchCall({ queries: dataBindings}).subscribe(data => {
          dataBindings[0]['identifierType'] = 'array';
          dataBindings[0]['identifier'] = 'events';
          let events = this._agregatorService.responeRestructure(data, dataBindings);
          events = get(events, '[0].events');
          this.currentEventDefs =  lodashMap(events, 'category.code');
          let allEvents: immutable.Map<string, IEvent> = immutable.Map();
          if (!isEmpty(events)) {
            this.prefetchForms();
            allEvents = immutable.Map(events.map(
              (item, index) => ([item.id, item])));
          }

          this.store$.dispatch({
            type: EVENT_ACTIONS.ADD_EVENTS,
            payload: allEvents
          });
          resolve('events resolved');
        });
      });
    });
     }


  /*** Get all events data from Store
   */
  public getAllEvents(): Observable<immutemap<string, IEvent>> {
    return this.store$.select('eventsData');
  }

  /*** Get all event definition
   */
  public getEventDefinition(eventCategory: string): Observable<IEventDefinition> {
    return this.store$.select('eventsDefinition').pipe(
      map((eventDefinitionMap: immutemap<string, IEventDefinition>) => {
        const def = eventDefinitionMap.get(eventCategory);
        return (def) ? def : eventDefinitionMap.get('default');
      })
    );
  }

  /*** Get all events definition from Store
   */
  public getAllEventDefinition(): Observable<immutemap<string, IEventDefinition>> {
    return this.store$.select('eventsDefinition');
  }

  /** Set selected event so that it can be viewed in report manager
   *  same can be set via timeline for viewing
   */
  public setSelectedEvent(event: IEvent) {
    this.store$.dispatch({
      type: EVENT_ACTIONS.CHANGE_SELECTED_EVENT,
      payload: event
    });
  }

  public setSelectedEventById(eventId: string) {
    this.getAllEvents().subscribe(data => {
      this.store$.dispatch({
        type: EVENT_ACTIONS.CHANGE_SELECTED_EVENT,
        payload: data.find(o => o.id === eventId)
      });
    });
  }

  /*** Get selected event from Store
   */
  public getSelectedEvent(): Observable<IEvent> {
    return this.store$.select('selectedEvent');
  }

  /**
   * Perform a map operation for event content.
   * Key of the map is the form key and value is the content array/object of that key.
   * @param selectedEvent
   */
  public selectedEventMap(eventMapParam: IEventMapParam, selectedEvent:IEvent):Map<string, any>{
    const eventFormKeyMap = new Map();
    const testNameMap: Map<string, Number> = new Map<string, Number>();
    if(has(selectedEvent, "content") && Array.isArray(selectedEvent.content)){
      let eventContentArray = selectedEvent.content;
      let eventContentArraySorted = [];
      if(eventMapParam.sortOrder !== undefined && eventMapParam.sortOrder.length > 0){
        eventContentArraySorted = sortBy(eventContentArray, eventMapParam.sortOrder);
      }else{
        eventContentArraySorted = eventContentArray;
      }
      let currentPriorityIndex: number = 0;
      let newPriorityIndex: number = -1;

      eventContentArraySorted.forEach((data, index) => {
        if(!isEmpty(data) && has(data, "formKey")){
          let eventDataArray: Array<any> = [];
          const formKey = data.formKey;
          if(has(data, "contentType")){
            delete data['contentType'];
          }
          if(has(data, "meta")){
            delete data['meta'];
          }
          if(eventFormKeyMap.has(formKey)){
            eventDataArray = eventFormKeyMap.get(formKey);
          }else {
            eventDataArray = [];
          }

          const currentData = data.data;
          // Rearranging the priority index(eventMapParam.groupMapping.modificationKey)
          // based on  eventMapParam.groupMapping.modificationKey from event in the DB.
          // This is because
          // a) Form data always give priority index as 0,1,2 etc
          // b) Data from event can come in a same order or different or starting from 2 etc.
          if( has(eventMapParam, ["groupMapping"]) &&
              has(eventMapParam, ["groupMapping", "modificationKey"]) &&
              has(eventMapParam, ["groupMapping", "associationKey"])){
             if(index === 0){
              newPriorityIndex = newPriorityIndex + 1;
              currentPriorityIndex = get(currentData, eventMapParam.groupMapping.modificationKey);
              currentData[eventMapParam.groupMapping.modificationKey]  = newPriorityIndex;
              testNameMap.set(get(currentData, eventMapParam.groupMapping.associationKey), newPriorityIndex);
            } else if(testNameMap.has(get(currentData, eventMapParam.groupMapping.associationKey))){
               currentData[eventMapParam.groupMapping.modificationKey] = testNameMap.get(get(currentData, eventMapParam.groupMapping.associationKey));
            }else{
              newPriorityIndex = newPriorityIndex + 1;
              currentData[eventMapParam.groupMapping.modificationKey]  = newPriorityIndex;
              testNameMap.set(get(currentData,eventMapParam.groupMapping.associationKey), newPriorityIndex);
            }
          }
          this.deleteBlankNullValues(currentData, eventMapParam.exclusionKeys);
          eventDataArray.push(currentData);
          eventFormKeyMap.set(formKey, eventDataArray);

        }
      });

    }
    return eventFormKeyMap;
  }

  /**
   * Method to compare two arrays are equal content.
   * @param formDataArray
   * @param eventDataArray
   */
  public arrayEquals(formDataArray: Array<any>, eventDataArray: Array<any> ):boolean{
    if(formDataArray === undefined && eventDataArray === undefined){
      return  true;
    } else if(
              (formDataArray === undefined && eventDataArray !== undefined)
              || (formDataArray !== undefined && eventDataArray === undefined)
              || (formDataArray.length !== eventDataArray.length) ){
      return false;
    }else{
      let arraysAreEquals = true;
      formDataArray.forEach((currentFormData) => {
        if (arraysAreEquals === false) {
          return ;
        }
        let InnerArrayEquals = false;
        eventDataArray.forEach((currentEventData) => {
          if (InnerArrayEquals === true) {
            return ;
          }
          const dataIsEquals = isEqual(currentFormData, currentEventData);
          if(dataIsEquals){
            InnerArrayEquals = true;
          }
        });

        if(InnerArrayEquals){
          arraysAreEquals = true;
        }else{
          arraysAreEquals = false;
        }
      });
      return arraysAreEquals;
    }

  }

  /**
   * Method to delete blank or null values from an aray with an additional filed
   * @param data
   * @param additionalKey
   */
  public deleteBlankNullValuesForArrays(data, additionalKeys: string[]){
    data.forEach((eachData) => {
      this.deleteBlankNullValues(eachData,additionalKeys);
    });
  }

  public  deleteBlankNullValues(eachData, additionalKeys: string[]){
    Object.keys(eachData).forEach((key) => {
      additionalKeys.forEach((additionalKey) => {
        if(has(eachData, additionalKey)){
          delete eachData[additionalKey];
        }
      });
      if(isNull(eachData[key])  ||  isEqual(eachData[key], "")){
        delete eachData[key];
      }else{
        //If date format in event content is YYYY-MM-DD then convert to dd MMM yyyy format
        // since form data comes in this format
        const isValidDate = moment(eachData[key], "YYYY-MM-DD", true).isValid();
        if(isValidDate){
          let newDate = new Date(eachData[key]);
          const dateString = this._datePipe.transform(newDate, "dd MMM yyyy");
          eachData[key] = dateString;
        }

      }
    });
  }
  /**
   * Update event
   * @param id
   * @param event
   */
  public updateEvent(id: string, event: IEvent, isArchive?: boolean, addExtraContext?:boolean): Observable<IEvent> {
    delete event['event_icon'];
    if(has(event, 'isExternalUpdate') && get(event, 'approved')) {
      set(event, 'isExternalUpdate', false);
    }
    if(addExtraContext) {
      let tempContext = cloneDeep(get(event, 'context'));
      if (!this.checkEventHasContext(event)) {
        this._contextProviderService.addContext(event, 'events');
        event['context'].push(...tempContext);
      }
    }

    this.store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: true
    });
    const req = this._ispmHttpClient.put('event/update', event).map(newEvent => {
        if (!isArchive) {
          this.store$.dispatch({
            type: EVENT_ACTIONS.UPDATE_EVENT,
            payload: {
              id,
              data: newEvent
            }
          });
          this.setSelectedEvent(newEvent);
        }
      this.store.dispatch({
        type: CORE_ACTIONS.SET_LOADER,
        payload: false
      });
      return newEvent;
      },
      error => {
        this.store.dispatch({
          type: CORE_ACTIONS.SET_LOADER,
          payload: false
        });
      }).publish();
    req.connect();
    return req;
  }

  /**
   * Create event
   * @param event
   */
  public createEvent(event: IEvent): Observable<IEvent> {
    let eventContexts = this._contextProviderService.getFormattedContext('events');
    if(eventContexts && eventContexts.length > 0) {
      let tempContext = cloneDeep(get(event, 'context'));
      this._contextProviderService.addContext(event, 'events');
      if (get(event, 'context')) {
        event['context'].push(...tempContext);
      } else {
        event['context'] = tempContext;
      }
    }
    const req = this._ispmHttpClient.post('event/create', event).map(newEvent => {
      this.store$.dispatch({
        type: EVENT_ACTIONS.UPDATE_EVENT,
        payload: {
          id: newEvent.id,
          data: newEvent
        }
      });
      return newEvent;
    }).publish();
    req.connect();
    return req;
  }

  /**
   * Copy event data to respective resource
   * @param reqBody
   */
  public mapToResource(reqBody: any): Observable<IEvent> {
    const req = this._ispmHttpClient.post('event/mapToResources', reqBody).map(newEvent => {
      this.store$.dispatch({
        type: EVENT_ACTIONS.UPDATE_EVENT,
        payload: {
          id: newEvent.id,
          data: newEvent
        }
      });
      return newEvent;
    }).publish();
    req.connect();
    return req;
  }

  public prefetchForms() {
    if ((this.allDefinitions.size > 0) && (this.currentEventDefs.length > 0) && !this.isformsFecthed) {
      this.isformsFecthed = true;
     this.formsPrefecth(this.currentEventDefs);
    }
  }

  public formsPrefecth(eventDefIds:Array<string>) {
    eventDefIds.forEach(type => {
      const eventDef = this.allDefinitions.get(type);
      const commonformConfig = get(eventDef, 'common.formsConfig');
      const uiConfigs = get(eventDef, 'ui.formsConfig');
      if (commonformConfig) {
        commonformConfig.forEach((config) => {
          if (config.hasOwnProperty('formId')) {
            this._formHandler.getForm(config.formId)
          }
        })
      }
      if (uiConfigs) {
        uiConfigs.forEach((config) => {
          if (config.hasOwnProperty('formId')) {
            this._formHandler.getForm(config.formId)
          }
        })
      }
    });
  }

  public clearEvents() {
    this.store$.dispatch({
      type: EVENT_ACTIONS.CLEAR_EVENTS,
      payload: { }
    });

    this.store$.dispatch({
      type: EVENT_ACTIONS.CHANGE_SELECTED_EVENT,
      payload: null
    });

    this.fileCached.clear();
  }


  private isDiagnosticReportPresent(context: Array<any>, evenDate: number, minDate: number, categoryFilter:boolean) {
    let diagnosticReportPresent = false;
    if (context.length === 0) {
      return diagnosticReportPresent;
    }
    for (let item of context) {
      if (item.resourceType && item.resourceType.toString().toLowerCase() === "diagnosticreport") {
        diagnosticReportPresent = true;
        break;
      }
    }
    return diagnosticReportPresent && evenDate >= minDate && categoryFilter;
  }


  /**
   * Get all events based on date
   * @param events
   * @param filterCategory
   * @param workFlowData
   * @return events
   */
  public getAllEventsBasedOnDate(events, filterCategory, workFlowData, filterParams):any {
    let {currentOrder, currentWorkflow, previousWorkflow} = workFlowData;
    let currentWorkflowId = get(currentWorkflow, 'id');
    let maxDate = get(currentWorkflow,'status','') === 'Running' ? this.getDateInMilliseconds(new Date().toString()) : this.getDateInMilliseconds(new Date(get(currentWorkflow, 'meta.lastUpdated')).toString());
    let lastYearDate = isEmpty(get(filterParams, ['duration','1'])) ? new Date().setFullYear(new Date().getFullYear() - 1) : new Date().setFullYear(new Date().getFullYear() - get(filterParams, ['duration','1']));
    let minDate = this.getDateInMilliseconds(new Date(lastYearDate).toString());
    let minDateForTestType = this.getDateInMilliseconds(get(filterParams,'eventOrWorkflowMinDate'));
    //TODO have the dedicated attribute for the completed workflow date instead of meta lastUpdated.
    if(previousWorkflow &&
        (
          get(previousWorkflow, 'revisions.[0].status') == 'Completed' ||
          get(previousWorkflow, 'revisions.[0].status') == 'Stopped'
        )
      ) {
      minDate =  this.getDateInMilliseconds(new Date(get(previousWorkflow, 'revisions.[0].meta.lastUpdated')).toString());
    }

    let filteredEvents = events.filter(event => {
      let categoryFilter = filterCategory ? get(filterCategory, 'code') === get(event, 'category.code') : true;
      let eventDate = this.getDateInMilliseconds(new Date(get(event, 'date')).toString());
      let eventContext = get(event, "context");
      let dateCondition = eventDate >= minDate && eventDate <= maxDate && categoryFilter;
      const dateConditionTestType = eventDate >= minDateForTestType && eventDate <= maxDate && categoryFilter;
      let contextCondition = this.checkEventHasContext(event);
      let emptyOrderInfo = this.checkEventHasOrderInfoEmpty(event);
      let wrExist = event['context'].filter(item => item['reference'] === currentWorkflowId);
      let diagnosticReportValue = this.isDiagnosticReportPresent(eventContext, eventDate, minDate, categoryFilter);
      const historicEvent = get(event,'historicalReport');
      if (historicEvent || (filterParams['workflowCreatedDate'] && wrExist && wrExist.length > 0 )) {
        return false;
      } else if (filterParams['workflowCreatedDate']) {
        return (dateConditionTestType && !event['approved'])  ||  (dateConditionTestType && emptyOrderInfo) || contextCondition || diagnosticReportValue;
      } else {
        return (dateCondition && !event['approved'])  || (dateCondition && emptyOrderInfo) || contextCondition;
      }
    });
    return filteredEvents;
  }

  /**
   * Extracts date from dateTimeStamp and returns the stored time value in milliseconds
   * Returns current date in milliseconds
   * @param dateTime accepts date in format of string
   */
  private getDateInMilliseconds(dateTime: string) {
    const isValidDate = !isNaN(new Date(dateTime).getTime());
    if (isValidDate) {
      const getDateString = new Date(dateTime).toDateString();
      return new Date(getDateString).getTime();
    }
    return new Date(new Date().toDateString()).getTime();
  }

  /**
   * check if event OrderInformation Empty
   * @param event
   */
  checkEventHasOrderInfoEmpty(event): boolean {
   const orderContext = event['context'].filter((context) => context['resourceType'] === 'OrderInformation');
   return orderContext.length === 1 ? false : true;
  }
  /**
   * Get file and cache file data
   * @param fileList
   */
  getAllFilesAndCache(fileList) {
    fileList.forEach(file => {
      let fileID = get(file, 'reference');
      if(!this.fileCached.has(fileID)) {
        let fileContent = this._fileService.getFileData(fileID);
        this.fileCached.set(fileID, fileContent);
      }
    });
  }



  /**
   * Get file from cache
   * @param fileID
   */
  getFileFromCache(fileID): Observable<any> {
    if(this.fileCached.has(fileID)) {
      return this.fileCached.get(fileID);
    } else {
      let fileContent = this._fileService.getFileData(fileID);
      this.fileCached.set(fileID, fileContent);
      return fileContent;
    }
  }

  /**
   * check if context is there
   * @param event
   */
  checkEventHasContext(event): boolean {
    let eventContexts = this._contextProviderService.getFormattedContext('events');
    return eventContexts.every(context => {
      let hasContext = false;
      event['context'].forEach(tempContext => {
        if (tempContext['reference'] === context['reference']) {
          hasContext = true;
        }
      });
      return hasContext;
    });
  }

  getDiagnosticOrderFromStore(): Promise<IDiagnosticOrder> {
    return this.appStore$.select(currentDiagnosticOrderSelector).pipe(distinctUntilChanged(), take(1)).toPromise();
  }

  setDiscardEventTabData(discardData: boolean){
    this.store$.dispatch({
      type: EVENT_ACTIONS.DISCARD_EVENT_TAB_DATA,
      payload: discardData
    });
  }

  getIsDiscardEventTabData(): Observable<boolean> {
    return this.store$.select('discardEventTabData');
  }

  public setViewWizard(value: boolean) {
    this.store$.dispatch({
      type: EVENT_ACTIONS.ADD_VIEW_WIZARD,
      payload: value
    })
    this.store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: false
    })
  }

   public getViewWizard(){
    return this.store$.select('viewWizard');
  }

  public clearViewWizard(){
    /*this.store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: true
    });*/
    this.setViewWizard(false);
   /* this.store.dispatch({
      type: CORE_ACTIONS.SET_LOADER,
      payload: false
    });*/
  }

  public notifyExtractWorkflow(id: string, event: any, backendURL: string, isArchive?: boolean, addExtraContext?: boolean): Observable<IEvent> {
    this.notificationMessageService.warning(this.notificationMessage.NLP_RUNNING);
    delete event['event_icon'];
    if (addExtraContext) {
      let tempContext = cloneDeep(get(event, 'context'));
      if (!this.checkEventHasContext(event)) {
        this._contextProviderService.addContext(event, 'events');
        event['context'].push(...tempContext);
      }
    }
    let workflowId = '';

    return this._ispmHttpClient.post('event/' + backendURL, event).pipe(
        map(newEvent => {
              workflowId = newEvent['workflowResponse'];
              newEvent = newEvent['createEventResponse'];
              newEvent = this.updateRedux(id, isArchive, workflowId, newEvent);
              return newEvent;
            },
            error => {
              this.notificationMessageService.error(this.notificationMessage.NLP_FAILED + error);
            })
    );
  }
  private interval = 10000;
  public updateRedux(id: string, isArchive?: boolean, workflowId?: string, newEvent?: Observable<IEvent>): Observable<IEvent> {

    let newInterval = true;
    if (!isArchive) {
      let counter = 20;
      let workflowState = '';
      this.stopInterval = setInterval(() => {
        if (counter != 0) {
          this._workflowService.getWorkflowRequest(workflowId).subscribe(workflowRes => {
            // If status 'Done' then Query Event Dat
            let latestRevisionStatus = workflowRes['latestRevisionStatus'];
            workflowState = latestRevisionStatus;

            if (RevisionStatus.WORKFLOW_STATUS.toString() === latestRevisionStatus.toString()) {
              return this._ispmHttpClient.get('event/getEvent/' + id).subscribe(eventData => {
                this.store$.dispatch({
                  type: EVENT_ACTIONS.UPDATE_EVENT,
                  payload: {
                    id,
                    data: eventData
                  }
                });
                this.setSelectedEvent(eventData);
                this.getAndStoreAllEventDefinitions();
                clearInterval(this.stopInterval);
                this.notificationMessageService.success("Extraction completed'; Pathology prostate event view updated");
                this.onCompleteWorkflow = of(eventData);
                return eventData;
              }, error => {
                this.notificationMessageService.error("Extraction completed!!!")
                return Observable.throw(error);
              }, () => {
              })
            }
          });
          if (workflowState !== '' && counter % 5 == 0) {
          }
          counter--;
        } else {
          if (newInterval) {
            clearTimeout(this.stopInterval)
            this.interval = 100000;
            counter = 10;
            newInterval = false;
          } else {
            clearInterval(this.stopInterval);
          }
        }
      }, this.interval);
      return newEvent;
    }
  }

  public setCurrentActiveFile(file:any){
    this.currentActiveFile.next(file);
  }

  public setIsButtonDisable(flag:boolean) {
    this.isButtonDisable.next(flag);
    this.isButtonDisable.complete();
  }
}
